import { Trans } from '@lingui/react/macro';

import Button from '@/design_system/Button';
import { Footer, FooterButtons } from '@/design_system/Footer';
import { ShipmentWithRelations, useCompleteInTransit } from '@/models/shipment';

const InTransitAction = ({
  shipment,
  onTransitDone,
}: {
  shipment: ShipmentWithRelations;
  onTransitDone: () => void;
}) => {
  const {
    mutateAsync: completeInTransit,
    isPending: isCompleteInTransitPending,
    isSuccess: isCompleteInTransitSuccess,
  } = useCompleteInTransit();

  return (
    <Footer>
      <FooterButtons>
        <Button
          variant="primary"
          onPress={async () => {
            await completeInTransit(shipment.id);
            onTransitDone();
          }}
          isLoading={isCompleteInTransitPending || isCompleteInTransitSuccess}
        >
          <Trans id="shipment.mark-as-received">Mark as received</Trans>
        </Button>
      </FooterButtons>
    </Footer>
  );
};

export default InTransitAction;
